module.exports = __webpack_public_path__ + "media/uitx1.86bd416f.mp4";